import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EEntityType, ERelationType } from '@web/dtos';
import { TranslationTextInputComponent } from '../../../../../components/data-input/form-inputs/translation-text-input/translation-text-input.component';
import { ButtonComponent } from '../../../../../components/feedback/button/button.component';
import { IFooterBlockForm } from '../../../../../entities/footer-entity';
import { LinkFormsFactoryService } from '../../../../../factory/link/link-forms-factory.service';
import { CmsTextProviderService } from '../../../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-footer-links-block-editor',
  imports: [
    ReactiveFormsModule,
    TranslationTextInputComponent,
    ButtonComponent,
  ],
  templateUrl: './footer-links-block-editor.component.html',
})
export class FooterLinksBlockEditorComponent {
  readonly block = input.required<FormGroup<IFooterBlockForm>>();
  readonly index = input.required<number>();

  protected readonly cmsTextProvider = inject(CmsTextProviderService);
  protected readonly EntityType = EEntityType;
  protected readonly TextRelationType = ERelationType;
  private readonly linkFormsFactory = inject(LinkFormsFactoryService);

  protected addLink(): void {
    const links = this.block().controls.links;
    links.push(
      this.linkFormsFactory.buildLinkFormGroup(undefined, links.length)
    );
    this.block().markAsDirty();
  }

  protected removeLink(index: number): void {
    this.block().controls.links.removeAt(index);
    this.updatePositions();
  }

  protected moveLink(index: number, direction: -1 | 1): void {
    const links = this.block().controls.links;
    const target = index + direction;
    if (target < 0 || target >= links.length) return;

    const link = links.at(index);
    links.removeAt(index, { emitEvent: false });
    links.insert(target, link, { emitEvent: false });
    this.updatePositions();
  }

  private updatePositions(): void {
    const links = this.block().controls.links;
    links.controls.forEach((link, index) =>
      link.controls.positionOrder.setValue(index, { emitEvent: false })
    );
    links.updateValueAndValidity();
    this.block().markAsDirty();
  }
}
